import { createReducer, on } from '@ngrx/store';
import {DashboardStatisticItem, RecentlyCreatedOrModifiedItems} from '../../shared/models/dashboard.model';
import * as DashboardActions from './dashboard.actions';
import {StateStatus} from "../../shared/models/state-status.models";

export interface DashboardState {
  recentActivity: RecentlyCreatedOrModifiedItems[];
  dashboardStatistics: DashboardStatisticItem;
  recentActivityStatus: StateStatus;
  dashboardStatisticsStatus: StateStatus;
  error: any;
}

export const initialState: DashboardState = {
  recentActivity: [],
  dashboardStatistics: {
    estimatedMaterialCost: 0,
    estimatedLaborCost: 0,
    estimatedLaborTime: 0,
    estimatedTotalCost: 0,
    estimatedRawMaterialWeight: 0,
  },
  recentActivityStatus: 'pending',
  dashboardStatisticsStatus: 'pending',
  error: null
};

export const dashboardReducer = createReducer(
  initialState,
  on(DashboardActions.loadRecentActivity, (state): DashboardState => ({
    ...state,
    recentActivityStatus: 'loading',
    error: null
  })),
  on(DashboardActions.loadRecentActivitySuccess, (state, { recentActivity }): DashboardState => ({
    ...state,
    recentActivity,
    recentActivityStatus: 'loadSuccess'
  })),
  on(DashboardActions.loadRecentActivityFailure, (state, { error }): DashboardState => ({
    ...state,
    error,
    recentActivityStatus: 'loadError'
  })),
  on(DashboardActions.loadDashboardStatistics, (state): DashboardState => ({
    ...state,
    recentActivityStatus: 'loading',
    error: null
  })),
  on(DashboardActions.loadDashboardStatisticsSuccess, (state, { dashboardStatistics }): DashboardState => ({
    ...state,
    dashboardStatistics,
    dashboardStatisticsStatus: 'loadSuccess'
  })),
  on(DashboardActions.loadDashboardStatisticsFailure, (state, { error }): DashboardState => ({
    ...state,
    error,
    dashboardStatisticsStatus: 'loadError'
  }))
);
